import { useFormContext } from 'react-hook-form';
import { Banner } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ReservationTimeState } from '@mews-commander/data-access';
import {
    CommonProcessPaymentFormModel,
    ProcessPaymentFormField,
} from '../forms/ProcessPayment/ProcessPaymentFormSchema';
import { useReservationsSearch } from './queries';

export const FutureStayBanner = () => {
    const { watch } = useFormContext<CommonProcessPaymentFormModel>();
    const selectedReservationId = watch(ProcessPaymentFormField.ServiceOrderId);
    const reservationSearch = useReservationsSearch(true);
    const { data } = reservationSearch(selectedReservationId || '');

    const selectedReservation = data?.find((r) => r.reservationId === selectedReservationId);
    const selectedReservationState = selectedReservation?.reservationTimeState;

    if (
        selectedReservationState === ReservationTimeState.Future ||
        selectedReservationState === ReservationTimeState.ToBeCheckedIn
    ) {
        return (
            <Banner
                variant="info"
                primaryText={lt(TextKey.ProcessPaymentLinkPaymentToReservationReservationBannerPrimaryText)}
                secondaryText={
                    <>
                        {lt(TextKey.ProcessPaymentLinkPaymentToReservationReservationBannerSecondaryText)}
                        {/* TODO: guidelink not yet ready
                        <NewTabLink url={createGuideLink(ArticlePath.HowToLinkPaymentToReservation)}>
                            {lt(TextKey.ProcessPaymentLinkPaymentToReservationReservationBannerLinkText)}
                        </NewTabLink>
                        */}
                    </>
                }
            />
        );
    }

    return null;
};
